module.exports = __webpack_public_path__ + "img/download_pc.e8ba09f2.png";